import styled from '@emotion/styled'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  padding: 18px;
  box-sizing: border-box;
  background: linear-gradient(0deg, rgba(28, 28, 28, 0.2) 0%, rgba(28, 28, 28, 0.2) 100%),
    url(${process.env.PUBLIC_URL}/img/bg-rp-dealer.png) lightgray 50% / cover repeat;
  font-family: 'SF Pro Display', sans-serif;

  * {
    font-family: 'SF Pro Display', sans-serif;
  }
`
